import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import styles from "./styles.module.scss";

// #region Sample data
const data = [
  {
    name: "01.11.2025",
    norma: 4,
    reality: 2,
  },
  {
    name: "02.11.2025",
    norma: 4,
    reality: 5.6,
  },
  {
    name: "03.11.2025",
    norma: 4,
    reality: 1,
  },
  {
    name: "04.11.2025",
    norma: 4,
    reality: 0,
  },
  {
    name: "05.11.2025",
    norma: 4,
    reality: 7,
  },
  {
    name: "06.11.2025",
    norma: 4,
    reality: 4,
  },
  {
    name: "07.11.2025",
    norma: 4,
    reality: 6,
  },
  {
    name: "01.11.2025",
    norma: 4,
    reality: 2,
  },
  {
    name: "02.11.2025",
    norma: 4,
    reality: 5.6,
  },
  {
    name: "03.11.2025",
    norma: 4,
    reality: 1,
  },
  {
    name: "04.11.2025",
    norma: 4,
    reality: 0,
  },
  {
    name: "05.11.2025",
    norma: 4,
    reality: 7,
  },
  {
    name: "06.11.2025",
    norma: 4,
    reality: 4,
  },
  {
    name: "07.11.2025",
    norma: 4,
    reality: 6,
  },
  {
    name: "01.11.2025",
    norma: 4,
    reality: 2,
  },
  {
    name: "02.11.2025",
    norma: 4,
    reality: 5.6,
  },
  {
    name: "03.11.2025",
    norma: 4,
    reality: 1,
  },
  {
    name: "04.11.2025",
    norma: 4,
    reality: 0,
  },
  {
    name: "05.11.2025",
    norma: 4,
    reality: 7,
  },
  {
    name: "06.11.2025",
    norma: 4,
    reality: 4,
  },
  {
    name: "07.11.2025",
    norma: 4,
    reality: 6,
  },
];
// #endregion

// #region Sample data
// const data = [
//   {
//     name: 'Page A',
//     uv: 4000,
//     pv: 2400,
//     // amt: 2400,
//   },
//   {
//     name: 'Page B',
//     uv: 3000,
//     pv: 1398,
//     // amt: 2210,
//   },
//   {
//     name: 'Page C',
//     uv: 2000,
//     pv: 9800,
//     // amt: 2290,
//   },
//   {
//     name: 'Page D',
//     uv: 2780,
//     pv: 3908,
//     // amt: 2000,
//   },
//   {
//     name: 'Page E',
//     uv: 1890,
//     pv: 4800,
//     // amt: 2181,
//   },
//   {
//     name: 'Page F',
//     uv: 2390,
//     pv: 3800,
//     // amt: 2500,
//   },
//   {
//     name: 'Page G',
//     uv: 3490,
//     pv: 4300,
//     // amt: 2100,
//   },
// ];
// #endregion

const Graphics = () => {
  return (
    <div style={{ marginLeft: "-30px", marginRight: "30px" }}>
      <div className={styles.wrapper}>
        <ResponsiveContainer width="100%" height="100%">
          <LineChart
            // width={200}
            // height={120}
            data={data}
            margin={{
              top: 5,
              right: 30,
              left: 20,
              bottom: 5,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis width={80} />
            <Tooltip />
            <Legend />
            <Line
              type="monotone"
              dataKey="reality"
              stroke="#8884d8"
              activeDot={{ r: 8 }}
            />
            <Line type="monotone" dataKey="norma" stroke="#82ca9d" />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
export default Graphics;
